export default __webpack_public_path__ + "static/media/1.3cde72a9.mp3";